export const BuilderComponentsDataProviderSymbol = Symbol('BuilderComponentsDataProvider')
